import React from 'react';
import styled from '@emotion/styled';
import { Icons } from '@bbkAdminUtils/icons';

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  newVariant?: boolean;
};

const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path
      d="M563.790488,48.3397954 L558,54.1367632 L552.209512,48.3397954 C551.760654,47.8904355 551.064566,47.8904355 550.615708,48.3397954 L549.336643,49.6202915 C548.887786,50.0696514 548.887786,50.7665188 549.336643,51.2158787 L555.127131,57.0128464 L549.359535,62.7868968 C548.910677,63.2362567 548.910677,63.9331241 549.359535,64.382484 L550.6386,65.6629801 C551.087457,66.11234 551.783546,66.11234 552.232404,65.6629801 L558,59.8433197 L563.790488,65.6402874 C564.239346,66.0896473 564.935434,66.0896473 565.384292,65.6402874 L566.663357,64.3597913 C567.112214,63.9104314 567.112214,63.213564 566.663357,62.7642041 L560.850201,56.9901537 L566.640689,51.193186 C567.089547,50.7438261 567.089547,50.0469587 566.640689,49.5975988 L565.361625,48.3171028 C564.934694,47.8905703 564.216679,47.8905703 563.790623,48.3399213 L563.790488,48.3397954 Z"
      transform="translate(-549 -48)"
    />
  </svg>
);

const OfferButton = styled.button`
  color: #9d9d9d;
  border: none;
  background: none;
  padding: 0px;
  display: flex;
  margin-left: 5px;
`;

const OfferButton2 = styled.button`
  background: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: none;
  outline: none;
  box-shadow: none;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CloseOfferButton: React.FC<Props> = ({
  onClick,
  newVariant,
  ...other
}) => {
  return newVariant ? (
    <OfferButton2 onClick={onClick} {...other}>
      {Icons.close18}
    </OfferButton2>
  ) : (
    <OfferButton onClick={onClick} {...other}>
      {closeIcon}
    </OfferButton>
  );
};
